

<div class="CaseSheet w-100">

    <div class="card" *ngIf="showAgentManagerCard">
        <div class="card-header">
            <div class="icon-wrapper">
                <img alt="websiteAndListings" class="icon" src="{{assetsUrl}}AgentPortalManager.png">
            </div>
            <div class="main-heading">
                Agent's<br>Portal Manager
            </div>
        </div>
        <div class="container">
            <div class="sub-heading">
                Within Portal Manager, you can manage
            </div>
            <ul class="list">
                <li>Photos, Bio/Contact Info</li>
                <li>QR Codes, MLS IDs</li>
                <li>Designations, Specialties</li>
                <li>Languages Spoken, Counties Served, Cities Served</li>
                <li>Profile and Website Display Options</li>
            </ul>
        </div>
        <div class="card-footer">
            <div class="btnHolder btn-fixed">
                <button type="button" class="primaryBtn" (click)="onManage('agent-info')">
                    Manage
                </button>
            </div>
        </div>
    </div>

    <div class="card" *ngIf="showAgentListing">
        <div class="card-header">
            <div class="icon-wrapper">
                <img alt="websiteAndListings" class="icon" src="{{assetsUrl}}AgentsWebsiteListing.png">
            </div>
            <div class="main-heading">
                Agent's<br>Website and Listings
            </div>
        </div>
        <div class="container">
            <div class="sub-heading">
                Within Website and Listings, you can manage
            </div>
            <ul class="list">
                <li>Manage Teams</li>
                <li>Manage Properties/Listing</li>
                <li>Manage Sold Homes</li>
                <li>Manage Websites</li>
                <li>Manage Coming Soon/Hotsheet Properties</li>
            </ul>
        </div>
        <div class="card-footer">
            <div class="btnHolder btn-fixed">
                <button type="button" class="primaryBtn" (click)="onManage('web-listing')">
                    Manage
                </button>
            </div>
        </div>
    </div>

    <div class="card" [ngClass]="{'LOBclass': isLOBUser}" *ngIf="!isBranchAdminUser && !isOfficeManagerSearchClicked">
        <div class="card-header">
            <div class="icon-wrapper">
                <img alt="websiteAndListings" class="icon" src="{{assetsUrl}}CoreServiceAssociation.png">
            </div>
            <div class="main-heading">
                Core Service<br>Associations
            </div>
        </div>
        <div class="container">
            <div class="sub-heading">
                Within core service association, you can manage
            </div>
            <ul class="list">
                <li>Manage Core Services – Sales Office Assignments</li>
            </ul>
        </div>
        <div class="card-footer">
            <div class="btnHolder btn-fixed">
                <button type="button" class="primaryBtn" (click)="onManage('core-employee')">
                    Manage
                </button>
            </div>
        </div>
    </div>
</div>